
const ja = {
  //新项目语言配置
  searchInformation:"検索情報",
  moreInformation:'より詳しい情報',
  noMore:"これ以上",
  allComments:'すべてのコメント',
  allReply:'全員に返信',
  wantToSay:'何を言いたいですか？',
  cancle:"キャンセル",
  publish:"リリース",
  pleaseEnterComment:'コメントを入力してください',
  peopleSaw: '人が見た',
  like: 'いいね',
  goodArticle:'良い記事、あなたの励ましが必要',
  fromLable: 'ラベルから',
  noLabel:'ラベルなし',
  relatedArticles:'関連記事',
  moreArticle: 'もっと多くの文章',
  everyoneSaying:'みんなが言っている',
  lookAll: 'すべてを調べる',
  pieceReply: '回の返事',
  noComment:'コメントデータはまだありません',
  oreComment:'もっとコメント',
  replySomeone:'返信する',
  noSearchResults: '検索の結果はまだない',
  viewMore: '詳細を調べる',
  searchRecords: '検索記録',
  clearRecords: '記録をクリアする',
  noSearchHistoryYet: '検索履歴はまだありません',
  noHotNews:'人気の記事はありません',
  hotArticle:'人気の記事',
  delete:'削除する',
  deleteCommentOk:'コメントの削除に成功しました',
  noData:'データがありません',
  requestFail:'リクエストに失敗しました',
  newsDataLoading:'情報データロード中',
  newsDataRequestTimeOut:'情報データの読み込みがタイムアウトしました。もう一度クリックしてください',
  doCommentFail:'コメント失敗',
  doLikeFail:'ポイントダウン',
  doCancelLikeFail:'ポイントのキャンセルに失敗しました',
  loading:'読み込み中...',
  loadFail:'ロードに失敗しました'
}
export default ja;



// WEBPACK FOOTER //
// ./src/i18n/config/ja.js